import initiateGoogleAds from "../initiateGoogleAds";

const handleOnloadingScript = (config, handleGoogleLoad) => {
  initiateGoogleAds(config, handleGoogleLoad);
};

export default handleOnloadingScript;
